import React from "react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { ClipboardList, Plus, Trash2, Upload } from "lucide-react";
import { findClient } from "../../lib/clientList";

// Files shared from trainer to client.
const FilesTab = ({
  clients,
  deleteSharedFile,
  fileTypeIcons,
  setFileShareOpen,
  setNewSharedFile,
  sharedFiles,
}) => {
  return (
    <div className="files-view">
      <div className="view-header">
        <h1>Udostępnione pliki</h1>
        <Button onClick={() => { setNewSharedFile({ name: "", url: "", file_type: "pdf", client_id: "", notes: "" }); setFileShareOpen(true); }}>
          <Plus size={18} /> Nowy plik
        </Button>
      </div>

      {sharedFiles.length === 0 ? (
        <Card className="empty-state">
          <CardContent className="empty-content">
            <Upload size={48} strokeWidth={1} />
            <h3>Brak plików</h3>
            <p>Udostępnij pliki swoim klientom</p>
          </CardContent>
        </Card>
      ) : (
        <div className="files-list">
          {sharedFiles.map(f => {
            const FileIcon = fileTypeIcons[f.file_type] || ClipboardList;
            const targetClient = f.client_id ? findClient(clients, f.client_id) : null;
            return (
              <Card key={f.id} className="file-card">
                <CardContent className="file-card-content">
                  <div className="file-icon-wrap">
                    <FileIcon size={20} />
                  </div>
                  <div className="file-info">
                    <a href={f.url} target="_blank" rel="noreferrer" className="file-name">{f.name}</a>
                    <div className="file-meta">
                      <Badge variant="outline">{f.file_type}</Badge>
                      <span>{targetClient ? targetClient.name : "Wszyscy klienci"}</span>
                      {f.notes && <span className="file-notes">- {f.notes}</span>}
                    </div>
                  </div>
                  <Button variant="ghost" size="sm" onClick={() => deleteSharedFile(f.id)}>
                    <Trash2 size={14} />
                  </Button>
                </CardContent>
              </Card>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default FilesTab;
